import React, { useEffect, useState } from 'react';

import { FormattedMessage, useIntl } from 'react-intl';

import { Typography, notification, Modal, Button, Divider } from 'antd';

import _service from '@netuno/service-client';

import Core from '../../../../../../../common/Core';

const langContext = 'reserved-area.marketplace';

const { Text, Title } = Typography;

export default ({ wasteTypeUID, uid, radius, onClose }) => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [isModalVisible, setIsModalVisible] = useState(false);
    useEffect(() => {
        if (uid) {
            setLoading(true);
            _service({
                method: 'GET',
                url: '/marketplace/waste/consume/list',
                data: {
                    uid: uid,
                    waste_type_uid: wasteTypeUID,
                    radius: radius
                },
                success: (response) => {
                    setData(response.json);
                    setLoading(false);
                },
                fail: (e) => {
                    setLoading(false);
                    notification['error']({
                        message: 'Não foi possivel carregar os dados.',
                        description: e.response.json.error,
                    });
                }
            });
        }
    }, []);

    const intl = useIntl();
    
    const onShowModal = () => {
        setIsModalVisible(true);
    };

    const onCancel = () => {
        setIsModalVisible(false);
        if (onClose) {
            onClose();
        }
    };

    return (
        <div>
            {data.map((item) => (
                <>
                    <Modal
                        title={intl.formatMessage({ id: langContext + '.waste.to-produce.title' })}
                        visible={true}
                        onCancel={onClose}
                        footer={[
                            <Button type='primary' onClick={onClose}>
                                <FormattedMessage id={`${langContext}.button.close`} />
                            </Button>]}
                    >
                        <Title level={4}><FormattedMessage id={langContext + `.fields.details`} /></Title>
                        <p>{intl.formatMessage({id: langContext + '.fields.distance'})}: <Text strong>{Core.numeral(item.distance)} Kms </Text></p>
                        <p>{intl.formatMessage({id: langContext + '.fields.radius'})}: <Text strong>{Core.numeral(item.waste_consume.radius)} Kms</Text></p>
                        <p>{intl.formatMessage({id: langContext + '.fields.estimated-date'})}: <Text strong>{item.waste_consume.estimated_date}</Text></p>
                        <Divider/>
                        <Title level={4}><FormattedMessage id={`reserved-area.construction.title`} /></Title>
                        <p>{intl.formatMessage({id: 'reserved-area.construction.title'})}: <Text strong>{item.name}</Text></p>
                        <p>{intl.formatMessage({id: langContext + '.fields.address'})}</p>
                        <p><Text strong>{item.address}</Text></p>
                        <p><Text strong>{item.postal_code} {item.locality}, {item.district}</Text></p>
                        <Divider/>
                        <Title level={4}><FormattedMessage id={`${langContext}.fields.waste`} /></Title>
                        <p>{intl.formatMessage({id: langContext + '.fields.description'})}: <Text strong>{item.waste_consume.waste_type.description[intl.locale.split('-')[0]]}</Text></p>
                        <p>{intl.formatMessage({id: langContext + '.fields.amount'})}: <Text strong>{item.waste_consume.amount} {item.waste_consume.measurement_unit.description[intl.locale.split('-')[0]]}</Text></p>
                    </Modal>
                </>
            ))}
        </div>
    )
}
